/** 当前选中的项目组 ID（项目管理员） */
export function normalizeProjectGroupIds(ids) {
  return (ids || [])
    .map(id => Number(id))
    .filter(id => !Number.isNaN(id))
}

export function getSelectedProjectGroupId(store) {
  const state = store && store.state ? store.state : store
  if (!state) return null
  const id = state.selectedProjectGroupId
  return id != null && !Number.isNaN(Number(id)) ? Number(id) : null
}

/** 与左上角下拉框一致：返回当前选中项目组的名称 */
export function getSelectedProjectGroupName(store) {
  const state = store && store.state ? store.state : store
  if (!state || !state.user) return ''
  const user = state.user
  if (user.roleCode !== 'PROJECT_ADMIN' && user.roleCode !== 'PROJECT_SUPERVISOR') return (user.projectGroupName || '').trim()

  const selectedId = getSelectedProjectGroupId(state)
  const ids = normalizeProjectGroupIds(user.projectGroupIds)
  const names = user.projectGroupNames || []

  if (selectedId != null) {
    const idx = ids.indexOf(selectedId)
    if (idx >= 0 && names[idx]) {
      return String(names[idx]).trim()
    }
  }

  if (names.length) {
    return String(names[0]).trim()
  }

  const legacy = (user.projectGroupName || '').trim()
  if (legacy && !legacy.includes('、')) {
    return legacy
  }
  return legacy.split('、').map(s => s.trim()).filter(Boolean)[0] || ''
}
